// import React, { useState } from 'react';
// import * as XLSX from 'xlsx';
// import { Table, Button, Form, Row, Col } from 'react-bootstrap';
// import { toast, ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import './ShipmentInfoTable.css';

// const ShipmentInfoTable = () => {
//     const [shipmentData, setShipmentData] = useState([]);
//     const [filteredData, setFilteredData] = useState([]);
//     const [filters, setFilters] = useState({
//         search: '',
//         shipmentDate: '',
//         shipmentShortDate: '',
//         actualPortArrivalDate: '',
//         estimatedPortArrivalDate: '',
//         arrivalLocation: '',
//         model: '',
//         variant: '',
//         colourCode: ''
//     });

//     const expectedHeaders = [
//         'Vehicle Identification Number',
//         'Shipment Date',
//         'Shipment Short Date',
//         'Actual Port Arrival Date',
//         'Shipment ID',
//         'Shipment Name',
//         'Shipping Reference',
//         'Vehicle Count',
//         'Estimated Port Arrival Date',
//         'Arrival Location',
//         'Model',
//         'Variant',
//         'Colour Code',
//         'Exterior Colour',
//         'Interior Colour',
//         'Interior Material',
//         'Stock Type'
//     ];

//     // Function to normalize headers
//     const normalizeHeader = (header) => header.trim().toLowerCase();

//     // Validate headers
//     const validateHeaders = (uploadedHeaders) => {
//         const normalizedExpected = expectedHeaders.map(normalizeHeader);
//         const normalizedUploaded = uploadedHeaders.map(normalizeHeader);
//         return normalizedExpected.every((header) => normalizedUploaded.includes(header));
//     };

//     // Convert Excel serial date to DD-MM-YYYY
//     const convertExcelDate = (serial) => {
//         if (!serial || isNaN(serial)) return serial; // If not a date, return as is
//         const utcDays = Math.floor(serial - 25569); // Excel's epoch is 25569 days after 01/01/1900
//         const date = new Date(utcDays * 86400 * 1000); // Convert days to milliseconds

//         // Format the date as DD-MM-YYYY
//         const day = String(date.getDate()).padStart(2, '0');
//         const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
//         const year = date.getFullYear();

//         return `${day}-${month}-${year}`;
//     };

//     // Handle file upload
//     const handleFileUpload = (event) => {
//         const file = event.target.files[0];
//         setShipmentData([]);
//         setFilteredData([]);

//         if (file) {
//             const validTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];
//             if (!validTypes.includes(file.type)) {
//                 toast.error('Invalid file type. Please upload an Excel file.');
//                 return;
//             }

//             const reader = new FileReader();
//             reader.onload = (e) => {
//                 const binaryData = e.target.result;
//                 const workbook = XLSX.read(binaryData, { type: 'binary' });
//                 const sheetName = workbook.SheetNames[0];
//                 const sheet = workbook.Sheets[sheetName];
//                 const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

//                 // Validate headers
//                 const uploadedHeaders = jsonData[0];
//                 if (!validateHeaders(uploadedHeaders)) {
//                     toast.error('Headers do not match the expected format. Please check your file.');
//                     return;
//                 }

//                 // Convert dates in specific columns (Assuming 1, 2, 3, 8 are date columns)
//                 const processedData = jsonData.slice(1).map((row) => {
//                     row[1] = convertExcelDate(row[1]); // Shipment Date
//                     row[2] = convertExcelDate(row[2]); // Shipment Short Date
//                     row[3] = convertExcelDate(row[3]); // Actual Port Arrival Date
//                     row[8] = convertExcelDate(row[8]); // Estimated Port Arrival Date
//                     return row;
//                 });

//                 setShipmentData(processedData);
//                 setFilteredData(processedData);
//                 toast.success('File uploaded successfully!');
//             };
//             reader.readAsBinaryString(file);
//         }
//     };

//     // Handle filters input changes
//     const handleFilterChange = (e) => {
//         const { name, value } = e.target;
//         setFilters({ ...filters, [name]: value });
//     };

//     // Apply filters when the button is clicked
//     const applyFilters = () => {
//         const filtered = shipmentData.filter((row) => {
//             const [vin, shipmentDate, shortDate, actualDate, shipmentId, shipmentName, , , estimatedDate, location, model, variant, colourCode] = row;
//             return (
//                 (!filters.search || vin?.toString().includes(filters.search) || shipmentId?.toString().includes(filters.search) || shipmentName?.toString().includes(filters.search)) &&
//                 (!filters.shipmentDate || shipmentDate === filters.shipmentDate) &&
//                 (!filters.shipmentShortDate || shortDate === filters.shipmentShortDate) &&
//                 (!filters.actualPortArrivalDate || actualDate === filters.actualPortArrivalDate) &&
//                 (!filters.estimatedPortArrivalDate || estimatedDate === filters.estimatedPortArrivalDate) &&
//                 (!filters.arrivalLocation || location === filters.arrivalLocation) &&
//                 (!filters.model || model === filters.model) &&
//                 (!filters.variant || variant === filters.variant) &&
//                 (!filters.colourCode || colourCode === filters.colourCode)
//             );
//         });
//         setFilteredData(filtered);
//     };

//     // Clear filters
//     const clearFilters = () => {
//         setFilters({
//             search: '',
//             shipmentDate: '',
//             shipmentShortDate: '',
//             actualPortArrivalDate: '',
//             estimatedPortArrivalDate: '',
//             arrivalLocation: '',
//             model: '',
//             variant: '',
//             colourCode: ''
//         });
//         setFilteredData(shipmentData);
//     };

//     return (
//         <div className="shipment-info-table mt-4">
//             <ToastContainer />

//             <Form.Group className="mb-3">
//                 <Form.Label>Upload Excel File</Form.Label>
//                 <Form.Control type="file" accept=".xlsx, .xls" onChange={handleFileUpload} />
//             </Form.Group>

//             {shipmentData.length > 0 && (
//                 <div className="filters mb-4">
//                     <Row>
//                         <Col md={4}>
//                             <Form.Control
//                                 type="search"
//                                 name="search"
//                                 placeholder="Search by VIN, Shipment ID, or Shipment Name"
//                                 value={filters.search}
//                                 onChange={handleFilterChange}
//                             />
//                         </Col>
//                         <Col md={2}>
//                             <Form.Control
//                                 as="select"
//                                 name="shipmentDate"
//                                 value={filters.shipmentDate}
//                                 onChange={handleFilterChange}
//                             >
//                                 <option value="">Filter by Shipment Date</option>
//                                 {[...new Set(shipmentData.map((row) => row[1]))].map((date) => (
//                                     <option key={date} value={date}>{date}</option>
//                                 ))}
//                             </Form.Control>
//                         </Col>
//                         <Col md={2}>
//                             <Form.Control
//                                 as="select"
//                                 name="shipmentShortDate"
//                                 value={filters.shipmentShortDate}
//                                 onChange={handleFilterChange}
//                             >
//                                 <option value="">Filter by Short Date</option>
//                                 {[...new Set(shipmentData.map((row) => row[2]))].map((date) => (
//                                     <option key={date} value={date}>{date}</option>
//                                 ))}
//                             </Form.Control>
//                         </Col>
//                         <Col md={2}>
//                             <Form.Control
//                                 as="select"
//                                 name="actualPortArrivalDate"
//                                 value={filters.actualPortArrivalDate}
//                                 onChange={handleFilterChange}
//                             >
//                                 <option value="">Filter by Actual Port Arrival</option>
//                                 {[...new Set(shipmentData.map((row) => row[3]))].map((date) => (
//                                     <option key={date} value={date}>{date}</option>
//                                 ))}
//                             </Form.Control>
//                         </Col>
//                     </Row>
//                     <Row className="mt-2">
//                         <Col md={2}>
//                             <Form.Control
//                                 as="select"
//                                 name="arrivalLocation"
//                                 value={filters.arrivalLocation}
//                                 onChange={handleFilterChange}
//                             >
//                                 <option value="">Filter by Arrival Location</option>
//                                 {[...new Set(shipmentData.map((row) => row[9]))].map((location) => (
//                                     <option key={location} value={location}>{location}</option>
//                                 ))}
//                             </Form.Control>
//                         </Col>
//                         <Col md={2}>
//                             <Form.Control
//                                 as="select"
//                                 name="model"
//                                 value={filters.model}
//                                 onChange={handleFilterChange}
//                             >
//                                 <option value="">Filter by Model</option>
//                                 {[...new Set(shipmentData.map((row) => row[10]))].map((model) => (
//                                     <option key={model} value={model}>{model}</option>
//                                 ))}
//                             </Form.Control>
//                         </Col>
//                         <Col md={2}>
//                             <Form.Control
//                                 as="select"
//                                 name="variant"
//                                 value={filters.variant}
//                                 onChange={handleFilterChange}
//                             >
//                                 <option value="">Filter by Variant</option>
//                                 {[...new Set(shipmentData.map((row) => row[11]))].map((variant) => (
//                                     <option key={variant} value={variant}>{variant}</option>
//                                 ))}
//                             </Form.Control>
//                         </Col>
//                         <Col md={2}>
//                             <Form.Control
//                                 as="select"
//                                 name="colourCode"
//                                 value={filters.colourCode}
//                                 onChange={handleFilterChange}
//                             >
//                                 <option value="">Filter by Colour Code</option>
//                                 {[...new Set(shipmentData.map((row) => row[12]))].map((code) => (
//                                     <option key={code} value={code}>{code}</option>
//                                 ))}
//                             </Form.Control>
//                         </Col>
//                     </Row>
//                     <Row className="mt-3">
//                         <Col>
//                             <Button variant="primary" onClick={applyFilters} className="me-2">
//                                 Apply Filters
//                             </Button>
//                             <Button variant="secondary" onClick={clearFilters}>
//                                 Clear Filters
//                             </Button>
//                         </Col>
//                     </Row>
//                 </div>
//             )}

//             {filteredData.length > 0 ? (
//                 <>
//                     <h3 className='text-center'>Shipment Info List</h3>
//                     <Table responsive striped bordered hover className="mt-3">
//                         <thead>
//                             <tr>
//                                 {expectedHeaders.map((header) => (
//                                     <th key={header}>{header}</th>
//                                 ))}
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {filteredData.map((row, rowIndex) => (
//                                 <tr key={rowIndex}>
//                                     {expectedHeaders.map((header, colIndex) => (
//                                         <td key={colIndex}>{row[colIndex]}</td>
//                                     ))}
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </Table>
//                 </>
//             ) : (
//                 <p className="text-center mt-4">No records found</p>
//             )}
//         </div>
//     );
// };

// export default ShipmentInfoTable;









// import React, { useState } from 'react';
// import * as XLSX from 'xlsx';
// import { Table, Button, Form, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
// import { toast, ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import './ShipmentInfoTable.css';

// const ShipmentInfoTable = () => {
//     const [shipmentData, setShipmentData] = useState([]);
//     const [filteredData, setFilteredData] = useState([]);
//     const [errors, setErrors] = useState({});
//     const [filters, setFilters] = useState({
//         search: '',
//         shipmentDate: '',
//         shipmentShortDate: '',
//         actualPortArrivalDate: '',
//         estimatedPortArrivalDate: '',
//         arrivalLocation: '',
//         model: '',
//         variant: '',
//         colourCode: ''
//     });

//     const expectedHeaders = [
//         'Vehicle Identification Number',
//         'Shipment Date',
//         'Shipment Short Date',
//         'Actual Port Arrival Date',
//         'Shipment ID',
//         'Shipment Name',
//         'Shipping Reference',
//         'Vehicle Count',
//         'Estimated Port Arrival Date',
//         'Arrival Location',
//         'Model',
//         'Variant',
//         'Colour Code',
//         'Exterior Colour',
//         'Interior Colour',
//         'Interior Material',
//         'Stock Type'
//     ];

//     const validationRules = {
//         'Vehicle Identification Number': (value) => /^[A-Z0-9]{17}$/.test(value) || 'VIN must be alphanumeric and 17 characters.',
//         'Shipment Date': (value) => /^\d{2}-\d{2}-\d{4}$/.test(value) || 'Shipment Date must be in DD-MM-YYYY format.',
//         'Shipment Short Date': (value) => /^[A-Za-z]+--\d{4}$/.test(value) || 'Shipment Short Date must be in format Month--Year.',
//         'Actual Port Arrival Date': (value) => /^\d{2}-\d{2}-\d{4}$/.test(value) || 'Actual Port Arrival Date must be in DD-MM-YYYY format.',
//         'Shipment ID': (value) => /^[1-9]\d*$/.test(value) || 'Shipment ID must be a positive number.',
//         'Shipment Name': (value) => /^[A-Za-z0-9 ]+$/.test(value) || 'Shipment Name must be alphanumeric.',
//         'Shipping Reference': (value) => /^[A-Za-z]{3}\d{2}\/\d{3}[A-Za-z]?$/.test(value) || 'Shipping Reference must be in SUZ24/033A format.',
//         'Vehicle Count': (value) => /^[1-9]\d*$/.test(value) || 'Vehicle Count must be a positive number.',
//         'Estimated Port Arrival Date': (value) => /^\d{2}-\d{2}-\d{4}$/.test(value) || 'Estimated Port Arrival Date must be in DD-MM-YYYY format.',
//         'Arrival Location': (value) => /^[A-Za-z ]+$/.test(value) || 'Arrival Location must be alphabetic.',
//         'Model': (value) => /^(Jimny|Ciaz|Ertiga|Eeco|Dzire|Baleno|Jimny 5DR|Carry|GrandVitara|Fronx)$/.test(value) || 'Invalid Model.',
//         'Variant': (value) => /^(Baleno\/15|Baleno\/20|Carry\/15|Ciaz\/18|Ciaz\/20|Dzire\/15|Dzire\/20|Eeco\/15|Ertiga\/15|Ertiga\/20|Fronx\/18|Fronx\/20|GRVitara\/12|GRVitara\/15|GRVitara\/20|GRVitara\/25|Jimny\/25|Jimny5DR\/25)$/.test(value) || 'Invalid Variant.',
//         'Colour Code': (value) => /^(2BW|CZW|ZZC|WBH|Z7Q|ZHJ|WBE|26U|DG5|Z2S|ZJ3|ZVL|ZVR|ZYA|WB3|ZAM|ZQK|ZYY|WBF|WBJ|WBG|ZTN|E5H|E5R|WA7|ZQD|C9J|ERD|ESL|ZYB|E85|ZZH|ZYE)$/.test(value) || 'Invalid Colour Code.',
//         'Exterior Colour': (value) => /^[A-Za-z /]+$/.test(value) || 'Invalid Exterior Colour.',
//         'Interior Colour': (value) => /^(Beige|Gray|Black)$/.test(value) || 'Invalid Interior Colour.',
//         'Interior Material': (value) => /^(Beige \(Cloth\)|Beige \(Leather\)|Black \(Cloth\)|Black \(Leather\)|Gray \(Cloth\))$/.test(value) || 'Invalid Interior Material.',
//         'Stock Type': (value) => /^(Unallocate|Damaged)$/.test(value) || 'Invalid Stock Type.'
//     };

//     const validateHeaders = (uploadedHeaders) => {
//         const normalizedExpected = expectedHeaders.map((header) => header.trim().toLowerCase());
//         const normalizedUploaded = uploadedHeaders.map((header) => header.trim().toLowerCase());
//         return normalizedExpected.every((header) => normalizedUploaded.includes(header));
//     };

//     const formatExcelDate = (excelDate) => {
//         if (!excelDate || isNaN(excelDate)) return excelDate;
//         const date = new Date((excelDate - 25569) * 86400 * 1000);
//         const day = String(date.getDate()).padStart(2, '0');
//         const month = String(date.getMonth() + 1).padStart(2, '0');
//         const year = date.getFullYear();
//         return `${day}-${month}-${year}`;
//     };


//     const validateData = (data) => {
//         const validationErrors = {};
//         data.forEach((row, rowIndex) => {
//             row.forEach((cell, colIndex) => {
//                 const header = expectedHeaders[colIndex];
//                 if (!cell || cell === '') {
//                     validationErrors[`${rowIndex}-${colIndex}`] = `${header} cannot be empty.`;
//                 } else if (validationRules[header]) {
//                     const error = validationRules[header](cell);
//                     if (error !== true) {
//                         validationErrors[`${rowIndex}-${colIndex}`] = error;
//                     }
//                 }
//             });
//         });
//         setErrors(validationErrors);
//     };

//     const handleFileUpload = (event) => {
//         const file = event.target.files[0];
//         setShipmentData([]);
//         setFilteredData([]);
//         setErrors({});

//         if (file) {
//             const validTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];
//             if (!validTypes.includes(file.type)) {
//                 toast.error('Invalid file type. Please upload an Excel file.');
//                 return;
//             }

//             const reader = new FileReader();
//             reader.onload = (e) => {
//                 const binaryData = e.target.result;
//                 const workbook = XLSX.read(binaryData, { type: 'binary' });
//                 const sheetName = workbook.SheetNames[0];
//                 const sheet = workbook.Sheets[sheetName];
//                 const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

//                 const processedData = jsonData.slice(1).map((row) =>
//                     row.map((cell, colIndex) => {
//                         if (colIndex === 1 || colIndex === 8) return formatExcelDate(cell); // Format Shipment Date & Estimated Port Arrival Date
//                         return cell;
//                     })
//                 );

//                 validateData(processedData);
//                 setShipmentData(processedData);
//                 setFilteredData(processedData);
//                 toast.success('File uploaded successfully!');
//             };
//             reader.readAsBinaryString(file);
//         }
//     };

//     const handleFilterChange = (e) => {
//         const { name, value } = e.target;
//         setFilters({ ...filters, [name]: value });
//     };

//     const applyFilters = () => {
//         const filtered = shipmentData.filter((row) => {
//             const [vin, shipmentDate, shortDate, actualDate, shipmentId, shipmentName, , , estimatedDate, location, model, variant, colourCode] = row;
//             return (
//                 (!filters.search || vin?.toString().includes(filters.search) || shipmentId?.toString().includes(filters.search) || shipmentName?.toString().includes(filters.search)) &&
//                 (!filters.shipmentDate || shipmentDate === filters.shipmentDate) &&
//                 (!filters.shipmentShortDate || shortDate === filters.shipmentShortDate) &&
//                 (!filters.actualPortArrivalDate || actualDate === filters.actualPortArrivalDate) &&
//                 (!filters.estimatedPortArrivalDate || estimatedDate === filters.estimatedPortArrivalDate) &&
//                 (!filters.arrivalLocation || location === filters.arrivalLocation) &&
//                 (!filters.model || model === filters.model) &&
//                 (!filters.variant || variant === filters.variant) &&
//                 (!filters.colourCode || colourCode === filters.colourCode)
//             );
//         });
//         setFilteredData(filtered);
//     };

//     const clearFilters = () => {
//         setFilters({
//             search: '',
//             shipmentDate: '',
//             shipmentShortDate: '',
//             actualPortArrivalDate: '',
//             estimatedPortArrivalDate: '',
//             arrivalLocation: '',
//             model: '',
//             variant: '',
//             colourCode: ''
//         });
//         setFilteredData(shipmentData);
//     };

//     return (
//         <div className="shipment-info-table mt-4">
//             <ToastContainer />

//             <Form.Group className="mb-3">
//                 <Form.Label>Upload Excel File</Form.Label>
//                 <Form.Control type="file" accept=".xlsx, .xls" onChange={handleFileUpload} />
//             </Form.Group>

//             {shipmentData.length > 0 && (
//                 <div className="filters mb-4">
//                     <Row>
//                         <Col md={4}>
//                             <Form.Control
//                                 type="search"
//                                 name="search"
//                                 placeholder="Search by VIN, Shipment ID, or Shipment Name"
//                                 value={filters.search}
//                                 onChange={handleFilterChange}
//                             />
//                         </Col>
//                         <Col md={2}>
//                             <Form.Control
//                                 as="select"
//                                 name="shipmentDate"
//                                 value={filters.shipmentDate}
//                                 onChange={handleFilterChange}
//                             >
//                                 <option value="">Filter by Shipment Date</option>
//                                 {[...new Set(shipmentData.map((row) => row[1]))].map((date) => (
//                                     <option key={date} value={date}>{date}</option>
//                                 ))}
//                             </Form.Control>
//                         </Col>
//                         <Col md={2}>
//                             <Form.Control
//                                 as="select"
//                                 name="shipmentShortDate"
//                                 value={filters.shipmentShortDate}
//                                 onChange={handleFilterChange}
//                             >
//                                 <option value="">Filter by Short Date</option>
//                                 {[...new Set(shipmentData.map((row) => row[2]))].map((date) => (
//                                     <option key={date} value={date}>{date}</option>
//                                 ))}
//                             </Form.Control>
//                         </Col>
//                         <Col md={2}>
//                             <Form.Control
//                                 as="select"
//                                 name="actualPortArrivalDate"
//                                 value={filters.actualPortArrivalDate}
//                                 onChange={handleFilterChange}
//                             >
//                                 <option value="">Filter by Actual Port Arrival</option>
//                                 {[...new Set(shipmentData.map((row) => row[3]))].map((date) => (
//                                     <option key={date} value={date}>{date}</option>
//                                 ))}
//                             </Form.Control>
//                         </Col>
//                     </Row>
//                     <Row className="mt-2">
//                         <Col md={2}>
//                             <Form.Control
//                                 as="select"
//                                 name="arrivalLocation"
//                                 value={filters.arrivalLocation}
//                                 onChange={handleFilterChange}
//                             >
//                                 <option value="">Filter by Arrival Location</option>
//                                 {[...new Set(shipmentData.map((row) => row[9]))].map((location) => (
//                                     <option key={location} value={location}>{location}</option>
//                                 ))}
//                             </Form.Control>
//                         </Col>
//                         <Col md={2}>
//                             <Form.Control
//                                 as="select"
//                                 name="model"
//                                 value={filters.model}
//                                 onChange={handleFilterChange}
//                             >
//                                 <option value="">Filter by Model</option>
//                                 {[...new Set(shipmentData.map((row) => row[10]))].map((model) => (
//                                     <option key={model} value={model}>{model}</option>
//                                 ))}
//                             </Form.Control>
//                         </Col>
//                         <Col md={2}>
//                             <Form.Control
//                                 as="select"
//                                 name="variant"
//                                 value={filters.variant}
//                                 onChange={handleFilterChange}
//                             >
//                                 <option value="">Filter by Variant</option>
//                                 {[...new Set(shipmentData.map((row) => row[11]))].map((variant) => (
//                                     <option key={variant} value={variant}>{variant}</option>
//                                 ))}
//                             </Form.Control>
//                         </Col>
//                         <Col md={2}>
//                             <Form.Control
//                                 as="select"
//                                 name="colourCode"
//                                 value={filters.colourCode}
//                                 onChange={handleFilterChange}
//                             >
//                                 <option value="">Filter by Colour Code</option>
//                                 {[...new Set(shipmentData.map((row) => row[12]))].map((code) => (
//                                     <option key={code} value={code}>{code}</option>
//                                 ))}
//                             </Form.Control>
//                         </Col>
//                     </Row>
//                     <Row className="mt-3">
//                         <Col>
//                             <Button variant="primary" onClick={applyFilters} className="me-2">
//                                 Apply Filters
//                             </Button>
//                             <Button variant="secondary" onClick={clearFilters}>
//                                 Clear Filters
//                             </Button>
//                         </Col>
//                     </Row>
//                 </div>
//             )}

//             {filteredData.length > 0 ? (
//                 <>
//                     <h3 className='text-center'>Shipment Info List</h3>
//                     <Table responsive striped bordered hover className="mt-3">
//                         <thead>
//                             <tr>
//                                 {expectedHeaders.map((header) => (
//                                     <th key={header}>{header}</th>
//                                 ))}
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {filteredData.map((row, rowIndex) => (
//                                 <tr key={rowIndex}>
//                                     {row.map((cell, colIndex) => (
//                                         <td className='w-50' key={colIndex}>
//                                             <Form.Control
//                                                 type="text"
//                                                 value={cell || ''} // Ensures the cell value is treated as controlled input
//                                                 readOnly
//                                                 isInvalid={!!errors[`${rowIndex}-${colIndex}`]} // Highlights the cell if there's an error
//                                             />
//                                             {errors[`${rowIndex}-${colIndex}`] && (
//                                                 <OverlayTrigger
//                                                     placement="top"
//                                                     overlay={<Tooltip>{errors[`${rowIndex}-${colIndex}`]}</Tooltip>}
//                                                 >
//                                                     <span className="ms-2 text-danger">
//                                                         <i className="bi bi-exclamation-circle-fill"></i>
//                                                     </span>
//                                                 </OverlayTrigger>
//                                             )}
//                                         </td>
//                                     ))}
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </Table>
//                 </>
//             ) : (
//                 <p className="text-center mt-4">No records found</p>
//             )}
//         </div>
//     );
// };

// export default ShipmentInfoTable;





// import React, { useState } from 'react';
// import * as XLSX from 'xlsx';
// import { Table, Button, Form, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
// import { toast, ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import './ShipmentInfoTable.css';

// const ShipmentInfoTable = () => {
//     const [shipmentData, setShipmentData] = useState([]);
//     const [filteredData, setFilteredData] = useState([]);
//     const [errors, setErrors] = useState({});
//     const [filters, setFilters] = useState({
//         search: '',
//         shipmentDate: '',
//         shipmentShortDate: '',
//         actualPortArrivalDate: '',
//         estimatedPortArrivalDate: '',
//         arrivalLocation: '',
//         model: '',
//         variant: '',
//         colourCode: ''
//     });

//     const expectedHeaders = [
//         'Vehicle Identification Number',
//         'Shipment Date',
//         'Shipment Short Date',
//         'Actual Port Arrival Date',
//         'Shipment ID',
//         'Shipment Name',
//         'Shipping Reference',
//         'Vehicle Count',
//         'Estimated Port Arrival Date',
//         'Arrival Location',
//         'Model',
//         'Variant',
//         'Colour Code',
//         'Exterior Colour',
//         'Interior Colour',
//         'Interior Material',
//         'Stock Type'
//     ];

//     const validationRules = {
//         'Vehicle Identification Number': (value) => /^[A-Z0-9]{17}$/.test(value) || 'VIN must be alphanumeric and 17 characters.',
//         'Shipment Date': (value) => /^\d{2}-\d{2}-\d{4}$/.test(value) || 'Shipment Date must be in DD-MM-YYYY format.',
//         'Shipment Short Date': (value) => /^[A-Za-z]+--\d{4}$/.test(value) || 'Shipment Short Date must be in format Month--Year.',
//         'Actual Port Arrival Date': (value) => /^\d{2}-\d{2}-\d{4}$/.test(value) || 'Actual Port Arrival Date must be in DD-MM-YYYY format.',
//         'Shipment ID': (value) => /^[1-9]\d*$/.test(value) || 'Shipment ID must be a positive number.',
//         'Shipment Name': (value) => /^[A-Za-z0-9 ]+$/.test(value) || 'Shipment Name must be alphanumeric.',
//         'Shipping Reference': (value) => /^[A-Za-z]{3}\d{2}\/\d{3}[A-Za-z]?$/.test(value) || 'Shipping Reference must be in SUZ24/033A format.',
//         'Vehicle Count': (value) => /^[1-9]\d*$/.test(value) || 'Vehicle Count must be a positive number.',
//         'Estimated Port Arrival Date': (value) => /^\d{2}-\d{2}-\d{4}$/.test(value) || 'Estimated Port Arrival Date must be in DD-MM-YYYY format.',
//         'Arrival Location': (value) => /^[A-Za-z ]+$/.test(value) || 'Arrival Location must be alphabetic.',
//         'Model': (value) => /^(Jimny|JIMNY|Ciaz|Ertiga|Eeco|Dzire|Baleno|Jimny 5DR|Carry|GrandVitara|Fronx)$/.test(value) || 'Invalid Model.',
//         'Variant': (value) => /^(Baleno\/15|Baleno\/20|Carry\/15|Ciaz\/18|Ciaz\/20|Dzire\/15|Dzire\/20|Eeco\/15|Ertiga\/15|Ertiga\/20|Fronx\/18|Fronx\/20|GRVitara\/12|GRVitara\/15|GRVitara\/20|GRVitara\/25|Jimny\/25|Jimny5DR\/25)$/.test(value) || 'Invalid Variant.',
//         'Colour Code': (value) => /^(2BW|CZW|ZZC|WBH|Z7Q|ZHJ|WBE|26U|DG5|Z2S|ZJ3|ZVL|ZVR|ZYA|WB3|ZAM|ZQK|ZYY|WBF|WBJ|WBG|ZTN|E5H|E5R|WA7|ZQD|C9J|ERD|ESL|ZYB|E85|ZZH|ZYE)$/.test(value) || 'Invalid Colour Code.',
//         'Exterior Colour': (value) => /^[A-Za-z /]+$/.test(value) || 'Invalid Exterior Colour.',
//         'Interior Colour': (value) => /^(Beige|Gray|Black)$/.test(value) || 'Invalid Interior Colour.',
//         'Interior Material': (value) => /^(Beige \(Cloth\)|Beige \(Leather\)|Black \(Cloth\)|Black \(Leather\)|Gray \(Cloth\))$/.test(value) || 'Invalid Interior Material.',
//         'Stock Type': (value) => /^(Unallocate|Damaged)$/.test(value) || 'Invalid Stock Type.'
//     };

//     const validateHeaders = (uploadedHeaders) => {
//         const normalizedExpected = expectedHeaders.map((header) => header.trim().toLowerCase());
//         const normalizedUploaded = uploadedHeaders.map((header) => header.trim().toLowerCase());
//         return normalizedExpected.every((header) => normalizedUploaded.includes(header));
//     };

//     const formatExcelDate = (excelDate) => {
//         if (!excelDate || isNaN(excelDate)) return excelDate;
//         const date = new Date((excelDate - 25569) * 86400 * 1000);
//         const day = String(date.getDate()).padStart(2, '0');
//         const month = String(date.getMonth() + 1).padStart(2, '0');
//         const year = date.getFullYear();
//         return `${day}-${month}-${year}`;
//     };

//     const validateData = (data) => {
//         const validationErrors = {};
//         data.forEach((row, rowIndex) => {
//             row.forEach((cell, colIndex) => {
//                 const header = expectedHeaders[colIndex];
//                 if (!cell || cell === '') {
//                     validationErrors[`${rowIndex}-${colIndex}`] = `${header} cannot be empty.`;
//                 } else if (validationRules[header]) {
//                     const error = validationRules[header](cell);
//                     if (error !== true) {
//                         validationErrors[`${rowIndex}-${colIndex}`] = error;
//                     }
//                 }
//             });
//         });
//         setErrors(validationErrors);
//     };

//     const handleFileUpload = (event) => {
//         const file = event.target.files[0];
//         setShipmentData([]);
//         setFilteredData([]);
//         setErrors({});

//         if (file) {
//             const validTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];
//             if (!validTypes.includes(file.type)) {
//                 toast.error('Invalid file type. Please upload an Excel file.');
//                 return;
//             }

//             const reader = new FileReader();
//             reader.onload = (e) => {
//                 const binaryData = e.target.result;
//                 const workbook = XLSX.read(binaryData, { type: 'binary' });
//                 const sheetName = workbook.SheetNames[0];
//                 const sheet = workbook.Sheets[sheetName];
//                 const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

//                 const uploadedHeaders = jsonData[0];
//                 if (!validateHeaders(uploadedHeaders)) {
//                     toast.error('Headers do not match the expected format. Please check your file.');
//                     return;
//                 }

//                 const processedData = jsonData.slice(1).map((row) =>
//                     row.map((cell, colIndex) => {
//                         if (colIndex === 1 || colIndex === 8) return formatExcelDate(cell); // Format Shipment Date & Estimated Port Arrival Date
//                         return cell;
//                     })
//                 );

//                 validateData(processedData);
//                 setShipmentData(processedData);
//                 setFilteredData(processedData);
//                 toast.success('File uploaded successfully!');
//             };
//             reader.readAsBinaryString(file);
//         }
//     };

//     const handleFilterChange = (e) => {
//         const { name, value } = e.target;
//         setFilters({ ...filters, [name]: value });
//     };

//     const applyFilters = () => {
//         const filtered = shipmentData.filter((row) => {
//             const [vin, shipmentDate, shortDate, actualDate, shipmentId, shipmentName, , , estimatedDate, location, model, variant, colourCode] = row;
//             return (
//                 (!filters.search || vin?.toString().includes(filters.search) || shipmentId?.toString().includes(filters.search) || shipmentName?.toString().includes(filters.search)) &&
//                 (!filters.shipmentDate || shipmentDate === filters.shipmentDate) &&
//                 (!filters.shipmentShortDate || shortDate === filters.shipmentShortDate) &&
//                 (!filters.actualPortArrivalDate || actualDate === filters.actualPortArrivalDate) &&
//                 (!filters.estimatedPortArrivalDate || estimatedDate === filters.estimatedPortArrivalDate) &&
//                 (!filters.arrivalLocation || location === filters.arrivalLocation) &&
//                 (!filters.model || model === filters.model) &&
//                 (!filters.variant || variant === filters.variant) &&
//                 (!filters.colourCode || colourCode === filters.colourCode)
//             );
//         });
//         setFilteredData(filtered);
//     };

//     const clearFilters = () => {
//         setFilters({
//             search: '',
//             shipmentDate: '',
//             shipmentShortDate: '',
//             actualPortArrivalDate: '',
//             estimatedPortArrivalDate: '',
//             arrivalLocation: '',
//             model: '',
//             variant: '',
//             colourCode: ''
//         });
//         setFilteredData(shipmentData);
//     };

//     return (
//         <div className="shipment-info-table mt-4">
//             <ToastContainer />

//             <Form.Group className="mb-3">
//                 <Form.Label>Upload Excel File</Form.Label>
//                 <Form.Control type="file" accept=".xlsx, .xls" onChange={handleFileUpload} />
//             </Form.Group>

//             {shipmentData.length > 0 && (
//                 <div className="filters mb-4">
//                     <Row>
//                         <Col md={4}>
//                             <Form.Control
//                                 type="search"
//                                 name="search"
//                                 placeholder="Search by VIN, Shipment ID, or Shipment Name"
//                                 value={filters.search}
//                                 onChange={handleFilterChange}
//                             />
//                         </Col>
//                         <Col md={2}>
//                             <Form.Control
//                                 as="select"
//                                 name="shipmentDate"
//                                 value={filters.shipmentDate}
//                                 onChange={handleFilterChange}
//                             >
//                                 <option value="">Filter by Shipment Date</option>
//                                 {[...new Set(shipmentData.map((row) => row[1]))].map((date) => (
//                                     <option key={date} value={date}>{date}</option>
//                                 ))}
//                             </Form.Control>
//                         </Col>
//                         <Col md={2}>
//                             <Form.Control
//                                 as="select"
//                                 name="shipmentShortDate"
//                                 value={filters.shipmentShortDate}
//                                 onChange={handleFilterChange}
//                             >
//                                 <option value="">Filter by Short Date</option>
//                                 {[...new Set(shipmentData.map((row) => row[2]))].map((date) => (
//                                     <option key={date} value={date}>{date}</option>
//                                 ))}
//                             </Form.Control>
//                         </Col>
//                         <Col md={2}>
//                             <Form.Control
//                                 as="select"
//                                 name="actualPortArrivalDate"
//                                 value={filters.actualPortArrivalDate}
//                                 onChange={handleFilterChange}
//                             >
//                                 <option value="">Filter by Actual Port Arrival</option>
//                                 {[...new Set(shipmentData.map((row) => row[3]))].map((date) => (
//                                     <option key={date} value={date}>{date}</option>
//                                 ))}
//                             </Form.Control>
//                         </Col>
//                     </Row>
//                     <Row className="mt-2">
//                         <Col md={2}>
//                             <Form.Control
//                                 as="select"
//                                 name="arrivalLocation"
//                                 value={filters.arrivalLocation}
//                                 onChange={handleFilterChange}
//                             >
//                                 <option value="">Filter by Arrival Location</option>
//                                 {[...new Set(shipmentData.map((row) => row[9]))].map((location) => (
//                                     <option key={location} value={location}>{location}</option>
//                                 ))}
//                             </Form.Control>
//                         </Col>
//                         <Col md={2}>
//                             <Form.Control
//                                 as="select"
//                                 name="model"
//                                 value={filters.model}
//                                 onChange={handleFilterChange}
//                             >
//                                 <option value="">Filter by Model</option>
//                                 {[...new Set(shipmentData.map((row) => row[10]))].map((model) => (
//                                     <option key={model} value={model}>{model}</option>
//                                 ))}
//                             </Form.Control>
//                         </Col>
//                         <Col md={2}>
//                             <Form.Control
//                                 as="select"
//                                 name="variant"
//                                 value={filters.variant}
//                                 onChange={handleFilterChange}
//                             >
//                                 <option value="">Filter by Variant</option>
//                                 {[...new Set(shipmentData.map((row) => row[11]))].map((variant) => (
//                                     <option key={variant} value={variant}>{variant}</option>
//                                 ))}
//                             </Form.Control>
//                         </Col>
//                         <Col md={2}>
//                             <Form.Control
//                                 as="select"
//                                 name="colourCode"
//                                 value={filters.colourCode}
//                                 onChange={handleFilterChange}
//                             >
//                                 <option value="">Filter by Colour Code</option>
//                                 {[...new Set(shipmentData.map((row) => row[12]))].map((code) => (
//                                     <option key={code} value={code}>{code}</option>
//                                 ))}
//                             </Form.Control>
//                         </Col>
//                     </Row>
//                     <Row className="mt-3">
//                         <Col>
//                             <Button variant="primary" onClick={applyFilters} className="me-2">
//                                 Apply Filters
//                             </Button>
//                             <Button variant="secondary" onClick={clearFilters}>
//                                 Clear Filters
//                             </Button>
//                         </Col>
//                     </Row>
//                 </div>
//             )}

//             {filteredData.length > 0 ? (
//                 <>
//                     <h3 className='text-center'>Shipment Info List</h3>
//                     <Table responsive striped bordered hover className="mt-3">
//                         <thead>
//                             <tr>
//                                 {expectedHeaders.map((header) => (
//                                     <th key={header}>{header}</th>
//                                 ))}
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {filteredData.map((row, rowIndex) => (
//                                 <tr key={rowIndex}>
//                                     {row.map((cell, colIndex) => (
//                                         <td key={colIndex}>
//                                             <Form.Control
//                                                 type="text"
//                                                 value={cell || ''}
//                                                 readOnly
//                                                 isInvalid={!!errors[`${rowIndex}-${colIndex}`]}
//                                             />
//                                             {errors[`${rowIndex}-${colIndex}`] && (
//                                                 <OverlayTrigger
//                                                     placement="top"
//                                                     overlay={<Tooltip>{errors[`${rowIndex}-${colIndex}`]}</Tooltip>}
//                                                 >
//                                                     <span className="ms-2 text-danger">
//                                                         <i className="bi bi-exclamation-circle-fill"></i>
//                                                     </span>
//                                                 </OverlayTrigger>
//                                             )}
//                                         </td>
//                                     ))}
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </Table>
//                 </>
//             ) : (
//                 <p className="text-center mt-4">No records found</p>
//             )}
//         </div>
//     );
// };

// export default ShipmentInfoTable;












import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import { Table, Button, Form, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './ShipmentInfoTable.css';

const ShipmentInfoTable = () => {
    const [shipmentData, setShipmentData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [errors, setErrors] = useState({});
    const [filters, setFilters] = useState({
        search: '',
        shipmentDate: '',
        shipmentShortDate: '',
        actualPortArrivalDate: '',
        estimatedPortArrivalDate: '',
        arrivalLocation: '',
        model: '',
        variant: '',
        colourCode: ''
    });

    const [currentPage, setCurrentPage] = useState(1); // Pagination state
    const itemsPerPage = 50; // Max items per page


    const expectedHeaders = [
        'Vehicle Identification Number',
        'Shipment Date',
        'Shipment Short Date',
        'Actual Port Arrival Date',
        'Shipment ID',
        'Shipment Name',
        'Shipping Reference',
        'Vehicle Count',
        'Estimated Port Arrival Date',
        'Arrival Location',
        'Model',
        'Variant',
        'Colour Code',
        'Exterior Colour',
        'Interior Colour',
        'Interior Material',
        'Stock Type'
    ];

    const validationRules = {
        'Vehicle Identification Number': (value) => /^[A-Z0-9]{17}$/.test(value) || 'VIN must be alphanumeric and 17 characters.',
        'Shipment Date': (value) => /^\d{2}-\d{2}-\d{4}$/.test(value) || 'Shipment Date must be in DD-MM-YYYY format.',
        'Shipment Short Date': (value) => /^[A-Za-z]+--\d{4}$/.test(value) || 'Shipment Short Date must be in format Month--Year.',
        'Actual Port Arrival Date': (value) => /^\d{2}-\d{2}-\d{4}$/.test(value) || 'Actual Port Arrival Date must be in DD-MM-YYYY format.',
        'Shipment ID': (value) => /^[1-9]\d*$/.test(value) || 'Shipment ID must be a positive number.',
        'Shipment Name': (value) => /^[A-Za-z0-9 ]+$/.test(value) || 'Shipment Name must be alphanumeric.',
        'Shipping Reference': (value) => /^[A-Za-z]{3}\d{2}\/\d{3}[A-Za-z]?$/.test(value) || 'Shipping Reference must be in SUZ24/033A format.',
        'Vehicle Count': (value) => /^[1-9]\d*$/.test(value) || 'Vehicle Count must be a positive number.',
        'Estimated Port Arrival Date': (value) => /^\d{2}-\d{2}-\d{4}$/.test(value) || 'Estimated Port Arrival Date must be in DD-MM-YYYY format.',
        'Arrival Location': (value) => /^[A-Za-z ]+$/.test(value) || 'Arrival Location must be alphabetic.',
        'Model': (value) => /^(Jimny|JIMNY|Ciaz|Ertiga|Eeco|Dzire|Baleno|Jimny 5DR|Carry|GrandVitara|Fronx)$/.test(value) || 'Invalid Model.',
        'Variant': (value) => /^(Baleno\/15|Baleno\/20|Carry\/15|Ciaz\/18|Ciaz\/20|Dzire\/15|Dzire\/20|Eeco\/15|Ertiga\/15|Ertiga\/20|Fronx\/18|Fronx\/20|GRVitara\/12|GRVitara\/15|GRVitara\/20|GRVitara\/25|Jimny\/25|Jimny5DR\/25)$/.test(value) || 'Invalid Variant.',
        'Colour Code': (value) => /^(2BW|CZW|ZZC|WBH|Z7Q|ZHJ|WBE|26U|DG5|Z2S|ZJ3|ZVL|ZVR|ZYA|WB3|ZAM|ZQK|ZYY|WBF|WBJ|WBG|ZTN|E5H|E5R|WA7|ZQD|C9J|ERD|ESL|ZYB|E85|ZZH|ZYE)$/.test(value) || 'Invalid Colour Code.',
        'Exterior Colour': (value) => /^[A-Za-z /]+$/.test(value) || 'Invalid Exterior Colour.',
        'Interior Colour': (value) => /^(Beige|Gray|Black)$/.test(value) || 'Invalid Interior Colour.',
        'Interior Material': (value) => /^(Beige \(Cloth\)|Beige \(Leather\)|Black \(Cloth\)|Black \(Leather\)|Gray \(Cloth\))$/.test(value) || 'Invalid Interior Material.',
        'Stock Type': (value) => /^(Unallocate|Damaged)$/.test(value) || 'Invalid Stock Type.'
    };

    const validateHeaders = (uploadedHeaders) => {
        const normalizedExpected = expectedHeaders.map((header) => header.trim().toLowerCase());
        const normalizedUploaded = uploadedHeaders.map((header) => header.trim().toLowerCase());
        return normalizedExpected.every((header) => normalizedUploaded.includes(header));
    };

    const formatExcelDate = (excelDate) => {
        if (!excelDate || isNaN(excelDate)) return excelDate;
        const date = new Date((excelDate - 25569) * 86400 * 1000);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const validateData = (data) => {
        const validationErrors = {};
        data.forEach((row, rowIndex) => {
            expectedHeaders.forEach((header, colIndex) => {
                const cell = row[colIndex] || '';
                if (!cell) {
                    validationErrors[`${rowIndex}-${colIndex}`] = `${header} cannot be empty.`;
                } else if (validationRules[header]) {
                    const error = validationRules[header](cell);
                    if (error !== true) {
                        validationErrors[`${rowIndex}-${colIndex}`] = error;
                    }
                }
            });
        });
        setErrors(validationErrors);
    };

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        setShipmentData([]);
        setFilteredData([]);
        setErrors({});
        setCurrentPage(1);

        if (file) {
            const validTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];
            if (!validTypes.includes(file.type)) {
                toast.error('Invalid file type. Please upload an Excel file.');
                return;
            }

            const reader = new FileReader();
            reader.onload = (e) => {
                const binaryData = e.target.result;
                const workbook = XLSX.read(binaryData, { type: 'binary' });
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];
                const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

                const uploadedHeaders = jsonData[0];
                if (!validateHeaders(uploadedHeaders)) {
                    toast.error('Headers do not match the expected format. Please check your file.');
                    return;
                }


                // Process the data and format specific date columns
                const processedData = jsonData.slice(1).map((row) =>
                    expectedHeaders.map((_, colIndex) => {
                        if (colIndex === 1 || colIndex === 3 || colIndex === 8) { // Columns for Shipment Date and Estimated Port Arrival Date
                            return formatExcelDate(row[colIndex]); // Format date to DD-MM-YYYY
                        }
                        return row[colIndex] || ''; // Default to empty string for missing values
                    })
                );


                validateData(processedData);
                setShipmentData(processedData);
                setFilteredData(processedData);
                toast.success('File uploaded successfully!');
            };
            reader.readAsBinaryString(file);
        }
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters({ ...filters, [name]: value });
    };

    const applyFilters = () => {
        const filtered = shipmentData.filter((row) => {
            const [vin, shipmentDate, shortDate, actualDate, shipmentId, shipmentName, , , estimatedDate, location, model, variant, colourCode] = row;
            return (
                (!filters.search || vin?.toString().includes(filters.search) || shipmentId?.toString().includes(filters.search) || shipmentName?.toString().includes(filters.search)) &&
                (!filters.shipmentDate || shipmentDate === filters.shipmentDate) &&
                (!filters.shipmentShortDate || shortDate === filters.shipmentShortDate) &&
                (!filters.actualPortArrivalDate || actualDate === filters.actualPortArrivalDate) &&
                (!filters.estimatedPortArrivalDate || estimatedDate === filters.estimatedPortArrivalDate) &&
                (!filters.arrivalLocation || location === filters.arrivalLocation) &&
                (!filters.model || model === filters.model) &&
                (!filters.variant || variant === filters.variant) &&
                (!filters.colourCode || colourCode === filters.colourCode)
            );
        });
        setFilteredData(filtered);
        setCurrentPage(1); // Reset to first page after applying filters
    };

    const clearFilters = () => {
        setFilters({
            search: '',
            shipmentDate: '',
            shipmentShortDate: '',
            actualPortArrivalDate: '',
            estimatedPortArrivalDate: '',
            arrivalLocation: '',
            model: '',
            variant: '',
            colourCode: ''
        });
        setFilteredData(shipmentData);
        setCurrentPage(1); // Reset to first page after clearing filters
    };

    // Pagination logic
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const paginatedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    const goToFirstPage = () => setCurrentPage(1);
    const goToPreviousPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
    const goToNextPage = () => setCurrentPage((prev) => Math.min(prev + 1, totalPages));
    const goToLastPage = () => setCurrentPage(totalPages);

    return (
        <div className="shipment-info-table mt-4">
            <ToastContainer />

            <Form.Group className="mb-3">
                <Form.Label>Upload Excel File</Form.Label>
                <Form.Control type="file" accept=".xlsx, .xls" onChange={handleFileUpload} />
            </Form.Group>

            {shipmentData.length > 0 && (
                <div className="filters mb-4">
                    <Row>
                        <Col md={4}>
                            <Form.Control
                                type="search"
                                name="search"
                                placeholder="Search by VIN, Shipment ID, or Shipment Name"
                                value={filters.search}
                                onChange={handleFilterChange}
                            />
                        </Col>
                        <Col md={2}>
                            <Form.Control
                                as="select"
                                name="shipmentDate"
                                value={filters.shipmentDate}
                                onChange={handleFilterChange}
                            >
                                <option value="">Filter by Shipment Date</option>
                                {[...new Set(shipmentData.map((row) => row[1]))].map((date) => (
                                    <option key={date} value={date}>{date}</option>
                                ))}
                            </Form.Control>
                        </Col>
                        <Col md={2}>
                            <Form.Control
                                as="select"
                                name="shipmentShortDate"
                                value={filters.shipmentShortDate}
                                onChange={handleFilterChange}
                            >
                                <option value="">Filter by Short Date</option>
                                {[...new Set(shipmentData.map((row) => row[2]))].map((date) => (
                                    <option key={date} value={date}>{date}</option>
                                ))}
                            </Form.Control>
                        </Col>
                        <Col md={2}>
                            <Form.Control
                                as="select"
                                name="actualPortArrivalDate"
                                value={filters.actualPortArrivalDate}
                                onChange={handleFilterChange}
                            >
                                <option value="">Filter by Actual Port Arrival</option>
                                {[...new Set(shipmentData.map((row) => row[3]))].map((date) => (
                                    <option key={date} value={date}>{date}</option>
                                ))}
                            </Form.Control>
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col md={2}>
                            <Form.Control
                                as="select"
                                name="arrivalLocation"
                                value={filters.arrivalLocation}
                                onChange={handleFilterChange}
                            >
                                <option value="">Filter by Arrival Location</option>
                                {[...new Set(shipmentData.map((row) => row[9]))].map((location) => (
                                    <option key={location} value={location}>{location}</option>
                                ))}
                            </Form.Control>
                        </Col>
                        <Col md={2}>
                            <Form.Control
                                as="select"
                                name="model"
                                value={filters.model}
                                onChange={handleFilterChange}
                            >
                                <option value="">Filter by Model</option>
                                {[...new Set(shipmentData.map((row) => row[10]))].map((model) => (
                                    <option key={model} value={model}>{model}</option>
                                ))}
                            </Form.Control>
                        </Col>
                        <Col md={2}>
                            <Form.Control
                                as="select"
                                name="variant"
                                value={filters.variant}
                                onChange={handleFilterChange}
                            >
                                <option value="">Filter by Variant</option>
                                {[...new Set(shipmentData.map((row) => row[11]))].map((variant) => (
                                    <option key={variant} value={variant}>{variant}</option>
                                ))}
                            </Form.Control>
                        </Col>
                        <Col md={2}>
                            <Form.Control
                                as="select"
                                name="colourCode"
                                value={filters.colourCode}
                                onChange={handleFilterChange}
                            >
                                <option value="">Filter by Colour Code</option>
                                {[...new Set(shipmentData.map((row) => row[12]))].map((code) => (
                                    <option key={code} value={code}>{code}</option>
                                ))}
                            </Form.Control>
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col>
                            <Button variant="primary" onClick={applyFilters} className="me-2">
                                Apply Filters
                            </Button>
                            <Button variant="secondary" onClick={clearFilters}>
                                Clear Filters
                            </Button>
                        </Col>
                    </Row>
                </div>
            )}

            {paginatedData.length > 0 ? (
                <>
                    <h3 className='text-center'>Shipment Info List</h3>
                    <Table responsive striped bordered hover className="mt-3">
                        <thead>
                            <tr>
                                {expectedHeaders.map((header) => (
                                    <th key={header}>{header}</th>
                                ))}
                            </tr>
                        </thead>
                        {/* <tbody>
                            {paginatedData.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    {row.map((cell, colIndex) => (
                                        <td key={colIndex}>
                                            <Form.Control
                                                type="text"
                                                value={cell || ''}
                                                readOnly
                                                isInvalid={!!errors[`${rowIndex}-${colIndex}`]}
                                            />
                                            {errors[`${rowIndex}-${colIndex}`] && (
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={<Tooltip>{errors[`${rowIndex}-${colIndex}`]}</Tooltip>}
                                                >
                                                    <span className="ms-2 text-danger">
                                                        <i className="bi bi-exclamation-circle-fill"></i>
                                                    </span>
                                                </OverlayTrigger>
                                            )}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody> */}

                        <tbody>
                            {paginatedData.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    {row.map((cell, colIndex) => {
                                        const errorKey = `${rowIndex}-${colIndex}`;
                                        return (
                                            <td key={colIndex}>
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        errors[errorKey] ? (
                                                            <Tooltip id={`tooltip-${errorKey}`}>{errors[errorKey]}</Tooltip>
                                                        ) : <></>
                                                    }
                                                >
                                                    <Form.Control
                                                        type="text"
                                                        value={cell || ''}
                                                        readOnly
                                                        isInvalid={!!errors[errorKey]}
                                                    />
                                                </OverlayTrigger>
                                            </td>
                                        );
                                    })}
                                </tr>
                            ))}
                        </tbody>

                    </Table>

                    {/* Pagination controls */}
                    <div className="pagination-controls mt-3 text-center">
                        <Button variant="secondary" onClick={goToFirstPage} disabled={currentPage === 1}>
                            First Page
                        </Button>
                        <Button variant="secondary" onClick={goToPreviousPage} disabled={currentPage === 1} className="mx-2">
                            Previous
                        </Button>
                        <span>
                            Page {currentPage} of {totalPages}
                        </span>
                        <Button variant="secondary" onClick={goToNextPage} disabled={currentPage === totalPages} className="mx-2">
                            Next
                        </Button>
                        <Button variant="secondary" onClick={goToLastPage} disabled={currentPage === totalPages}>
                            Last Page
                        </Button>
                    </div>


                </>
            ) : (
                <p className="text-center mt-4">No records found</p>
            )}
        </div>
    );
};

export default ShipmentInfoTable;
